// ============== UTILITY FUNCTIONS ==============

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Helper to resolve media URLs - handles both relative and absolute URLs
export const resolveMediaUrl = (url) => {
  if (!url) return null;
  // If it's already an absolute URL, return as-is
  if (url.startsWith('http://') || url.startsWith('https://') || url.startsWith('data:')) {
    return url;
  }
  // For relative URLs (like /api/uploads/...), prepend BACKEND_URL
  return `${BACKEND_URL}${url}`;
};

// Helper to get WebSocket URL from backend URL
export const getWebSocketUrl = () => {
  if (!BACKEND_URL) return null;
  const wsProtocol = BACKEND_URL.startsWith('https://') ? 'wss://' : 'ws://';
  const baseUrl = BACKEND_URL.replace(/^https?:\/\//, '');
  return `${wsProtocol}${baseUrl}/ws/scores`;
};

export const formatDate = (dateStr) => {
  if (!dateStr) return '';
  const d = new Date(dateStr);
  return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
};

export const formatTime = (dateStr) => {
  if (!dateStr) return '';
  const d = new Date(dateStr);
  return d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });
};

export const getYouTubeEmbedUrl = (url) => {
  if (!url) return null;
  const match = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([^&\s]+)/);
  return match ? `https://www.youtube.com/embed/${match[1]}` : url;
};

export const getStatusColor = (status) => {
  switch (status?.toLowerCase()) {
    case 'live': return 'bg-red-500';
    case 'upcoming': return 'bg-sky-500';
    case 'finished': return 'bg-gray-500';
    default: return 'bg-gray-500';
  }
};
